<mcg-window #ventana [width]="356" [height]="94" [title]="translate('Itinerarios')" [containerSelector]="'#map-container'"
  [canResize]="false" (windowClosed)="onClose()">
  <div class="form" style="float:left; overflow: hidden;">
    <div style="float: left;">
        <input #inputIni id="itiIni" class="search-group" type="text" (keydown.enter)="$event.preventDefault()"
            placeholder="{{translate('Introduzca_origen')}}" autocorrect="off" autocapitalize="off" spellcheck="off"
            list="ini-lista" on-focus="onOrigenFocus($event)">
        <datalist id="ini-lista">
        </datalist>
        <input #inputFin id="itiFin" class="search-group2" type="text" (keydown.enter)="$event.preventDefault()"
            placeholder="{{translate('Introduzca_destino')}}" autocorrect="off" autocapitalize="off"
            spellcheck="off" list="fin-lista" on-focus="onDestinoFocus($event)">
        <datalist id="fin-lista">
        </datalist>
    </div>
    <div style="float: left;">
        <jqxButton style="float: left; margin-left: 4px;" [width]='32' [height]='53'
            [imgSrc]='"/assets/images/refresh.png"' (onClick)="onAlternar($event)">
        </jqxButton>
    </div>
  </div>
</mcg-window>
